import { render } from "./TicketDetail.vue?vue&type=template&id=028deaf9&scoped=true&ts=true"
import script from "./TicketDetail.vue?vue&type=script&lang=ts"
export * from "./TicketDetail.vue?vue&type=script&lang=ts"

import "./TicketDetail.vue?vue&type=style&index=0&id=028deaf9&scoped=true&lang=less"
import "./TicketDetail.vue?vue&type=style&index=1&id=028deaf9&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028deaf9"]])

export default __exports__